






































































































import { Component, Watch, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPopover } from "bootstrap-vue";

@Component({
  components: {
    BPopover,
  },
  computed: mapState("gaps", ["logTypes"]),
})
export default class LogTypeFilter extends Vue {
  @Watch("searchText")
  onModelChanged() {
    this.filteredItems();
  }

  id = "log-type-filter-popover";
  target = "log-type-filter-target";
  logTypes!: Array<any>;
  list = Array<any>();
  listTemp = Array<any>();
  searchText: string = "";
  checkLogType() {
    this.list.forEach((s) => {
      s.checked = true;
    });
  }
  uncheckLogType() {
    this.list.forEach((s) => {
      s.checked = false;
    });
  }
  get checkedLogType(): Array<any> {
    return this.list
      .filter((s) => {
        return s.checked;
      })
      .map((s) => s.id);
  }

  filteredItems() {
    if (this.searchText) {
      this.list = this.listTemp.filter((item) => {
        return item["name"]
          .toLowerCase()
          .includes(this.searchText.toLowerCase());
      });
    }else{
      this.list = this.listTemp;
    }
  }

  search() {
    const filter = JSON.parse(JSON.stringify(this.checkedLogType));
    this.$store.commit("gaps/SET_LOG_TYPE_FILTER", filter);
    this.$emit("refresh");
    this.close();
  }
  clear() {
    this.uncheckLogType();
    this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    const { logTypeList } = this.$store.state.gaps.filter;
    this.list = JSON.parse(JSON.stringify(this.logTypes)).map((t) => {
      t.checked = logTypeList.includes(t.id);
      return t;
    });

    this.listTemp =this.list.slice();
  }
}
